import {inviteMemberToOrganisation, validateMemberToOrganisation, getOrganisationsTeam, validateMemberToTeam, inviteMemberToTeam, getUserSuggestions, updateInvitation, validateBillingManagerToOrganisation, inviteBillingManagerToOrganisation, validateCollaboratorToTeam, inviteCollaboratorToTeam, getMetaCollectionList, collaboratorSearchList, teamMemberSearchList, getMetaDossierList, getIamRole} from '@/libs/api/api'
import {message, errorHandler, logout, loader} from '@/libs/helper'
import {cloneDeep, uniq, isEmpty, isEqual} from 'lodash'
import constants from '@/libs/constant/constants'
import InfiniteLoading from 'vue-infinite-loading';
import OrganisationRolesErrorHandlerMixin from '@/mixins/OrganisationRolesErrorHandlerMixin'

export default {
    name: 'InvitePeople',
    components: {InfiniteLoading},
    mixins: [OrganisationRolesErrorHandlerMixin],
    props: {
        organisationDetails: {
            type: Object,
            default: () => {}
        },
        closeInviteDialog: {
            type: Function,
            default: () => {}
        },
        isCallFromTeam: {
            type: Boolean,
            default: false
        },
        isCollaborator: {
            type: Boolean,
            default: false
        },
        refreshLogs: {
            type: Function,
            default: () => {}
        },
        isUpdateInvitation: {
            type: Boolean,
            default: false
        },
        refreshPeopleList: {
            type: Function,
            default: () => {}
        },
        invitationToBeUpdated: {
            type: Object,
            default: () => {}
        },
        isBillingManager: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: 'Invite'
        },
        isOrganisation: {
            type: Boolean,
            default: false
        },
        hasPermission: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        isDisabledCollections () {
            return !this.isLoadMore || this.isFetchingCollections
        },
        isDisabledDossiers () {
            return !this.isLoadMoreDossiers || this.isFetchingDossiers
        }
    },
    mounted() {
        if (this.isUpdateInvitation) this.getUpdatedResults()
        this.fetchIamRoles()
    },
    data() {
        return {
            isEmpty,
            inviteInput: '',
            isValidated: false,
            isBillingManagerValidated: false,
            debounce: null,
            selectedCollaboratorRight: 'EDIT',
            role: '',
            is_collaborator: false,
            rolesList: [],
            teams: [],
            isInvite: false,
            isFetchingTeams: false,
            selectedTeams: [],
            selectedCollections: [],
            selectedUser: {},
            collectionList: [],
            isBusy: false,
            isLoadMore: true,
            isFetchingCollections: false,
            skip: 0,
            limit: 30,
            dossierSkip: 0,
            isFetchingDossiers: false,
            dossierList: [],
            isLoadMoreDossiers: true
        }
    },
    methods: {
        async fetchIamRoles() {
            let params = ''
            let searchValue = ''
            let body = {searchText: searchValue, type: this.isCallFromTeam ? 'TEAM' : 'ORGANISATION'}
            await getIamRole(this.organisationDetails._id , params, body)
                .then((response) => {
                    console.log('rolesssss',response)
                    this.rolesList = response.result.items.map((role) => {
                        return {
                            role: role.name,
                            _id: role._id
                        }
                    })
                })
                .catch((error) => {
                    message(this, constants.messageType.ERROR, (error))
                })
        },
        /**
         * validate people step 1 org
         * step1 - 
         */
        addPeopleStepOne () {
            this.isInvite = true
            // body for api
            let body = {
                organisation: this.$route.params.id || this.organisationDetails._id,
                member: this.selectedUser._id
            }
            // api call to validate field
            validateMemberToOrganisation(body).then(response => {
                if (response.success) {
                    this.isValidated = true
                    this.fetchTeams()
                }
                this.isInvite = false
            }).catch(error => {
                this.isValidated = false
                this.isInvite = false
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                // error handler for permissions
                this.rolesErrorHandler(error)
            })
        },
        /**
         * invite people to org
         * step 2
         */
        async addPeopleStepTwo () {
            // api call
            try {
                loader(this, true)
                // body for api
                let body = {
                    organisation: this.$route.params.id || this.organisationDetails._id,
                    member: this.selectedUser._id,
                    is_collaborator: this.is_collaborator
                }
                // teams
                if (!isEmpty(this.selectedTeams)) body.teams = this.selectedTeams
                // api call
                let response = await inviteMemberToOrganisation(body)
                // success
                if (response.success) {
                    this.refreshLogs()
                    message(this, constants.messageType.SUCCESS, 'Invite sent successfully')
                    // close invite popup
                    this.closeInviteDialog()
                }
                loader(this, false)
            } catch (error) {
                console.log(error)
                // error
                loader(this, false)
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                // error handler for permissions
                this.rolesErrorHandler(error)
            }
        },
        /**
         * step1 - add member to team
         */
        addTeamStepOne () {
            this.isInvite = true
            // body for api
            let body = {
                organisation: this.$route.params.id || this.organisationDetails._id,
                team: this.$route.params.tid,
                member: this.selectedUser._id
            }
            // api call to validate field
            validateMemberToTeam(body).then(response => {
                if (response.success) {
                    this.isValidated = true
                    // fetch collections
                    this.fetchCollections()
                    // fetch dossiers
                    this.fetchDossiers()
                }
                this.isInvite = false
            }).catch(error => {
                this.isInvite = false
                this.isValidated = false
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                // error handler for permissions
                this.rolesErrorHandler(error, true)
            })
        },

        /**
         * fetch teams
         */
        fetchTeams (isFetchMore) {
            // params
            let params = {
                skip: this.skip,
                limit: this.limit
            }
            this.isBusy = true
            this.isFetchingTeams = true
            // api call
            getOrganisationsTeam({organisation: this.$route.params.id || this.organisationDetails._id}, params).then(response => {
                // set Teams
                if (isFetchMore) this.teams = this.teams.concat(response.items || [])
                else this.teams = response.items || []
                if (response.total_count < this.limit) {
                    this.isLoadMore = false
                }
                this.isFetchingTeams = false
                this.skip += this.limit
                this.isBusy = false
            }).catch(error => {
                this.isFetchingTeams = false
                this.isBusy = false
                this.isLoadMore = false
                // error message
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },

        /**
         * change checkbox handler
         * @param {*} event 
         * @param {*} id 
         */
        changeTeamHandler (event, id) {
            // selected teams
            let selectedTeams = cloneDeep(this.selectedTeams)
            // if true then push
            if (event) {
                selectedTeams.push(id)
            } else {
                // else pop
                selectedTeams = selectedTeams.filter(item => item !== id)
            }
            // uniq ids
            this.selectedTeams = uniq(selectedTeams)
        },

        /**
         * to change the rights of collection
         */
        changeCollectionRights () {},

        /**
         * invite member to team
         * step 2
         */
        async addMemberStepTwo () {
            // api call
            try {
                loader(this, true)
                let body = {
                    organisation: this.$route.params.id || this.organisationDetails._id,
                    member: this.selectedUser._id,
                    role: this.role.toUpperCase(),
                    team: this.$route.params.tid,
                }
                if (!isEmpty(this.selectedTeams)) body.teams = this.selectedTeams
                let response = await inviteMemberToTeam(body)
                if (response.success) {
                    message(this, constants.messageType.SUCCESS, 'Invite sent successfully')
                    this.refreshLogs()
                    this.closeInviteDialog()
                }
                loader(this, false)
            } catch (error) {
                loader(this, false)
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                // error handler for permissions
                this.rolesErrorHandler(error, true)
            }
        },

        /**
         * query search
         */
        async querySearch (search, cb) {
           try {
                // check
            if ((search && search === '') || (search && search.length < 2)) return
            // body for api
            let body = {
                search_text: search
            }
            let result = []
            // api call
            let response = await this.querySearchAPI(body)
            result = response.USERS || []
            cb(result)
           } catch (error) {
            console.error(error)
           }
        },

        /**
         * to get the api for searching
         * @param {*} body 
         */
        querySearchAPI (body) {
            // if add members of team 
            if (this.isCallFromTeam) {
                body.organisation = this.$route.params.id || this.organisationDetails._id
                return teamMemberSearchList(body)
            }
            // if add collaborator
            else if (this.isCollaborator) {
                body.organisation = this.$route.params.id || this.organisationDetails._id
                if (!this.isOrganisation) body.team = this.$route.params.tid
                return collaboratorSearchList(body)
            }
            // suggestions for other list from accura system
            else return getUserSuggestions(body)
        },

        /**
         * handle select
         */
        handleSelect (item) {
            this.selectedUser = item
            this.inviteInput = `${item.first_name} ${item.last_name}`
        },
        /**
         * 
         */
        handleInfiniteLoading () {
            if (!this.isBusy && this.isLoadMore) this.fetchTeams(true)
        },
        /**
         * to set the result if it is update invitation screen
         */
        getUpdatedResults () {
            // to set the selected teams
            this.selectedTeams = (this.invitationToBeUpdated && this.invitationToBeUpdated.organisationinviterequests && this.invitationToBeUpdated.organisationinviterequests.teams) || []
            // set the role
            this.role = (this.invitationToBeUpdated && this.invitationToBeUpdated.organisationinviterequests && this.invitationToBeUpdated.organisationinviterequests.role && this.invitationToBeUpdated.organisationinviterequests.role.toLowerCase()) || 'member'
            // to switch to step two to update the results
            this.isValidated = true
            // fetch teams 
            this.fetchTeams()
        },

        /**
         * disable invite button
         */
        disabledUpdateButton () {
            let isDisabled = true
            // check teams changed
            if (this.invitationToBeUpdated && this.invitationToBeUpdated.organisationinviterequests && this.invitationToBeUpdated.organisationinviterequests.teams && !isEqual(this.selectedTeams, this.invitationToBeUpdated.organisationinviterequests.teams)) isDisabled = false
            // check roles changed
            if (this.invitationToBeUpdated && this.invitationToBeUpdated.organisationinviterequests && this.invitationToBeUpdated.organisationinviterequests.role && this.invitationToBeUpdated.organisationinviterequests.role.toLowerCase() !== this.role) isDisabled = false
            return isDisabled
        },
        /**
         * step one invite screen
         */
        inviteStepOne () {
            // condition for selecting the action of first screen(invite)
            this.isBillingManager ? this.addBillingMangerStepOne() : this.isCallFromTeam ? this.addTeamStepOne() : this.isCollaborator ? this.addCollaboratorStepOne() : this.addPeopleStepOne()
        },

        /**
         * step one invite screen
         */
        inviteStepTwo () {
            // condition for selecting the action of second screen(invite)
            this.isBillingManager ? this.inviteBillingMangerStepTwo() : this.isUpdateInvitation ? this.updatePeopleInvitation() : this.isCallFromTeam ? this.addMemberStepTwo() : this.isCollaborator ? this.inviteCollaboratorStepTwo() : this.addPeopleStepTwo()
        },
        /**
         * first step of billing manager to ORG
         */
        async addBillingMangerStepOne () {
            try {
                this.isInvite = true
                // body for api
                let body = {
                    organisation: this.$route.params.id || this.organisationDetails._id,
                    member: this.selectedUser._id
                }
                // api call to validate field
                let response = await validateBillingManagerToOrganisation(body)
                if (response.success) {
                    // this.isValidated = true
                    this.isBillingManagerValidated = true
                }
                this.isInvite = false
            } catch (error) {
                    this.isInvite = false
                    this.isValidated = false
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                    // error handler for permissions
                    this.rolesErrorHandler(error)
            }
        },
        /**
         * second step for adding billing manger to ORG
         */
        async inviteBillingMangerStepTwo () {
            try {
                loader(this, true)
                // body for api
                let body = {
                    organisation: this.$route.params.id || this.organisationDetails._id,
                    member: this.selectedUser._id
                }
                // api call
                let response = await inviteBillingManagerToOrganisation(body)
                // on success show message and closes the popup
                if (response.success) {
                    message(this, constants.messageType.SUCCESS, 'Invite sent successfully')
                    this.closeInviteDialog()
                }
                loader(this, false)
            } catch (error) {
                loader(this, false)
                // error message
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                // error handler for permissions
                this.rolesErrorHandler(error)
            }
        },
        /**
         * to update the people pending invitation
         */
        async updatePeopleInvitation () {
            try {
                loader(this, true)
                // body for api
                let body = {
                    role: this.role.toUpperCase(),
                    teams: this.selectedTeams
                }
                // api call
               let response = await updateInvitation(body, this.invitationToBeUpdated.organisationinviterequests._id)
               loader(this, false)
                // success message
               message(this, constants.messageType.SUCCESS, response.message)
                // close dialog
               this.closeInviteDialog()
                // refresh the current people list
               this.refreshPeopleList(1)
            } catch (error) {
                loader(this, false)
                // error message
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                // error handler for permissions
                this.rolesErrorHandler(error)
            }
        },
        /**
         * first step of billing manager to ORG
         */
        async addCollaboratorStepOne () {
            try {
                this.isInvite = true
                // body for api
                let body = {
                    invite_for_type: this.organisationDetails.type === constants.LIST.REGULAR_COLLECTION ? constants.LIST.COLLECTION : constants.LIST.DOSSIER,
                    invite_for_id: this.organisationDetails._id,
                    member: this.selectedUser._id,
                    organisation: this.$route.params.id || this.organisationDetails._id,
                    team: this.$route.params.tid
                }
                if (this.isOrganisation) delete body.team
                // api call to validate field
                let response = await validateCollaboratorToTeam(body)
                if (response.success) {
                    this.isValidated = true
                }
                this.isInvite = false
            } catch (error) {
                    this.isInvite = false
                    this.isValidated = false
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                    // error handler for permissions
                    this.rolesErrorHandler(error, !this.isOrganisation)
            }
        },
        /**
         * second step for adding billing manger to ORG
         */
        async inviteCollaboratorStepTwo () {
            try {
                loader(this, true)
                // body for api
                let body = {
                    invite_for_type: this.organisationDetails.type === constants.LIST.REGULAR_COLLECTION ? constants.LIST.COLLECTION : constants.LIST.DOSSIER,
                    invite_for_id: this.organisationDetails._id,
                    member: this.selectedUser._id,
                    organisation: this.$route.params.id || this.organisationDetails._id,
                    team: this.$route.params.tid,
                    role: this.selectedCollaboratorRight
                }
                if (this.isOrganisation) delete body.team
                // api call
                let response = await inviteCollaboratorToTeam(body)
                // on success show message and closes the popup
                if (response.success) {
                    message(this, constants.messageType.SUCCESS, 'Invite sent successfully')
                    this.closeInviteDialog()
                }
                loader(this, false)
            } catch (error) {
                loader(this, false)
                // error message
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                // error handler for permissions
                this.rolesErrorHandler(error, !this.isOrganisation)
            }
        },

        /**
         * disbale button checks for save (step 2)
         */
        disabledSaveButton () {
            // check for collaborator rights
            if (this.isCollaborator && this.selectedCollaboratorRight === '') return true
            return false
        },

        /**
         * to change right of collaborators
         * @param {*} right 
         */
        changeCollaboratorRight (right) {
            this.selectedCollaboratorRight = this.selectedCollaboratorRight === right ? '' : right
        },

        /**
         *  to fetch the collections
         */
        fetchCollections (isLoadMore) {
            this.isFetchingCollections = true
            // paarams for api
            let params = {
                skip: this.skip,
                limit: this.limit
            }
            // body for api
            let body = {
                entity_type: constants.ORGANISATIONS.TEAM,
                entity_id: this.$route.params.tid
            }
            // api call
            getMetaCollectionList(body, params)
            .then(response => {
                // if loading more than concat the list
                if (isLoadMore) this.collectionList = this.collectionList.concat(response.items || [])
                // initialise the list
                else this.collectionList = response.items || []
                // increase the skip
                this.skip += this.limit
                if (response.item_count < this.limit) {
                    this.isLoadMore = false
                }
                // to make fetching false
                this.isFetchingCollections = false
            })
            .catch(() => {
                this.clearFields()
            })
        },

        /**
         * to fetch collections 
         */
        async fetchDossiers (isLoadMore) {
            try {
                this.isFetchingDossiers = true
                // params for api
                let params = {
                    skip: this.dossierSkip,
                    limit: this.limit
                }
                // body for api
                let body = {
                    entity_type: constants.ORGANISATIONS.TEAM,
                    entity_id: this.$route.params.tid
                }
                // api call
                let response = await getMetaDossierList(body, params)
                // if loading more than concat the list
                if (isLoadMore) this.dossierList = this.dossierList.concat(response.items || [])
                // initialise the list
                else {
                    this.dossierList = response.items || []
                    // this.selectedCollection = (response.items && response.items[0]) || {}
                }
                // increase the skip
                this.dossierSkip += this.limit
                if (response.item_count < this.limit) {
                    this.isLoadMoreDossiers = false
                }
            } catch (error) {
                this.isLoadMoreDossiers = false
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            }
            // to make fetching false
            this.isFetchingDossiers = false
        },
        /**
         * to clear the fields
         */
        clearFields () {
            this.isLoadMore = true
            this.isFetchingCollections = false
            this.skip = 0
        },

        /**
         * infinite loading handler collection
         */
        handleCollectionInfiniteLoading () {
            if (!this.isFetchingCollections && this.isLoadMore) this.fetchCollections(true)
        },

        /**
         * infinite loading handler dossier
         */
        handleDossierInfiniteLoading () {
            if (!this.isFetchingDossiers && this.isLoadMoreDossiers) this.fetchDossiers(true)
        },
    }
}